<template>
  <div :class="['product-price-group', { 'product-price-group--main': main }]">
    <div v-if="heading" class="product-price-group__heading">
      {{ heading }}
    </div>

    <template v-if="main">
      <div class="product-price-group__price">
        {{ formatPrice(selectedPrice) }}
      </div>
      <div class="product-price-group__vat">
        {{ selectedVatLabel }}
      </div>
    </template>

    <div v-else class="product-price-group__line">
      {{ formatPrice(selectedPrice) }} {{ selectedVatLabel }}{{ suffix }}
    </div>

    <div v-if="showOtherLine" class="product-price-group__line">
      {{ formatPrice(otherPrice) }} {{ otherVatLabel }}{{ suffix }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

/**
 * One price, shown the way the visitor's VAT switch says, with the other way beneath it (OC-3012).
 * The chosen figure is the large one in a main group, and a reference group (ordinary price, list
 * price) is a single small line. The other line is left out when asked to, and whenever the two
 * figures are the same, which is the case for a customer who pays no VAT.
 */
export default {
  props: {
    priceExVat: {
      type: Number,
      default: null
    },
    priceIncVat: {
      type: Number,
      default: null
    },
    heading: {
      type: String,
      default: ''
    },
    // Put right after each VAT label, as in "/st" on a volume price.
    suffix: {
      type: String,
      default: ''
    },
    main: {
      type: Boolean,
      default: false
    },
    showOther: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('ui', ['useVat']),
    selectedPrice() {
      return this.useVat ? this.priceIncVat : this.priceExVat
    },
    otherPrice() {
      return this.useVat ? this.priceExVat : this.priceIncVat
    },
    selectedVatLabel() {
      return this.useVat ? this.tStatic('priceIncludingVat') : this.tStatic('priceExcludingVat')
    },
    otherVatLabel() {
      return this.useVat ? this.tStatic('priceExcludingVat') : this.tStatic('priceIncludingVat')
    },
    showOtherLine() {
      return this.showOther &&
        this.priceExVat !== null && this.priceIncVat !== null &&
        Math.abs(this.priceIncVat - this.priceExVat) >= 0.005
    }
  }
}
</script>

<style lang="scss">
.product-price-group + .product-price-group {
  margin-top: measure(eighth);
}

.product-price-group__heading {
  @include caption-semi-bold;
}

.product-price-group__price {
  @include h2-bold;
  min-height: 1.4rem;
}

.product-price-group__vat,
.product-price-group__line {
  @include caption;
}
</style>
